<template>
  <v-text-field
    solo
    flat
    :height="height"
    :readonly="readonly"
    :disabled="disabled"
    :maxlength="maxLength"
    :type="type"
    color="var(--theme-color-one)"
    :class="[
      'custom-textfield-theme-' + theme,
      textAlign + 'Text',
      { 'error-input': error },
    ]"
    :hide-details="hideDetails"
    :placeholder="readonly ? '' : placeholder"
    :oninput="returnOninput"
    :value="value"
    @keypress.enter="eventKeyEnter"
    @change="eventChange"
    @input="eventChange"
    @click:clear="eventClear"
  >
    <template v-slot:append-inner>
      <Iconify :icon="appendInnerIcon"></Iconify>
    </template>

    <template v-slot:append>
      <v-btn
        v-if="appendIcon"
        width="30"
        height="30"
        dark
        fab
        depressed
        color="#F5F5F5"
      >
        <Iconify style="color: #f15a29" :icon="appendIcon"></Iconify>
      </v-btn>
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: "TextField",
  props: {
    placeholder: {
      default: "โปรดระบุ",
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    height: {
      default: "36",
    },
    error: {
      default: false,
    },
    appendInnerIcon: {
      default: undefined,
    },
    appendIcon: {
      default: null,
    },
    theme: {
      default: "1",
    },
    textAlign: {
      default: "start",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {
      default: "",
    },
    inputType: {
      default: "",
    },
    type: {
      default: "text",
    },
    maxLength: {
      default: 524288,
    },
  },
  computed: {
    returnOninput() {
      switch (this.inputType) {
        case "number":
          return "value=value.replace(/[^\\d]/g,'')"; // only number

        case "decimal":
          return "value=value.replace(/[^0-9\\.]/g,'')"; // only number and decimal

        case "no-comma":
          return "value=value.replace(/,/g,'')"; // without comma

        default:
          return null;
      }
    },
  },
  methods: {
    eventChange(val) {
      this.$emit("onChange", val);
    },
    eventKeyEnter() {
      this.$emit("onEnter");
    },
    eventClear() {
      this.$emit("onClear");
    },
  },
};
</script>

<style scoped lang="scss"></style>
